export const OLYMPIC_SPORTS = {
  'ALP': {
    'code': 'ALP',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/athletics.svg',
    'isPara': false,
    'name': 'Alpine Skiing'
  },
  'BOB': {
    'code': 'BOB',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/climbing.svg',
    'isPara': false,
    'name': 'Bobsleigh'
  },
  'BTH': {
    'code': 'BTH',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/bmx-freestyle.svg',
    'isPara': false,
    'name': 'Biathlon'
  },
  'CCS': {
    'code': 'CCS',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/athletics.svg',
    'isPara': false,
    'name': 'Cross-Country Skiing'
  },
  'CUR': {
    'code': 'CUR',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/bmx-racing.svg',
    'isPara': false,
    'name': 'Curling'
  },
  'FRS': {
    'code': 'FRS',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/artistic-swimming.svg',
    'isPara': false,
    'name': 'Freestyle Skiing'
  },
  'FSK': {
    'code': 'FSK',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/artistic-gymnastics.svg',
    'isPara': false,
    'name': 'Figure Skating'
  },
  'IHO': {
    'code': 'IHO',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/canoe-sprint.svg',
    'isPara': false,
    'name': 'Ice Hockey'
  },
  'LUG': {
    'code': 'LUG',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/basketball-3x3.svg',
    'isPara': false,
    'name': 'Luge'
  },
  'NCB': {
    'code': 'NCB',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/breaking.svg',
    'isPara': false,
    'name': 'Nordic Combined'
  },
  'SBD': {
    'code': 'SBD',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/archery.svg',
    'isPara': false,
    'name': 'Snowboard'
  },
  'SJP': {
    'code': 'SJP',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/beach-volleyball.svg',
    'isPara': false,
    'name': 'Ski Jumping'
  },
  'SKN': {
    'code': 'SKN',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/canoe-slalom.svg',
    'isPara': false,
    'name': 'Skeleton'
  },
  'SMT': {
    'code': 'SMT',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/cycling-road.svg',
    'isPara': false,
    'name': 'Ski Mountaineering'
  },
  'SSK': {
    'code': 'SSK',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/basketball.svg',
    'isPara': false,
    'name': 'Speed Skating'
  },
  'STK': {
    'code': 'STK',
    'iconUrl': 'https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/boxing.svg',
    'isPara': false,
    'name': 'Short Track Speed Skating'
  }
}
